/* import __COLOCATED_TEMPLATE__ from './grid-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();